// extracted by mini-css-extract-plugin
export default {"openInTab":"TypoGraph_openInTab__izwKu"};